import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import InputNumber from 'modules/_shared/components/InputNumber';
import { formatNumber } from 'utils/formats';
import { CustomRange } from '../types/CustomRange';

type EntireClassRenumerationPreviewProps = {
  ranges: CustomRange[];
  totalRanges: number;
  totalShares: number;
  sampleSize?: number;
};

const EntireClassRenumerationPreview: FC<
  EntireClassRenumerationPreviewProps
> = ({ ranges, totalRanges, totalShares, sampleSize = 5 }) => {
  const { t } = useTranslate();

  const sample = ranges.slice(0, sampleSize);
  const remaining = totalRanges - sample.length;

  return (
    <div className="entire-class-preview">
      <div className="entire-class-preview__metrics">
        <div className="entire-class-preview__metric">
          <span className="entire-class-preview__n">
            {formatNumber(totalRanges)}
          </span>
          <span className="entire-class-preview__l">{t('Ranges')}</span>
        </div>
        <div className="entire-class-preview__metric">
          <span className="entire-class-preview__n">
            {formatNumber(totalShares)}
          </span>
          <span className="entire-class-preview__l">{t('Shares')}</span>
        </div>
        <div className="entire-class-preview__metric entire-class-preview__metric--accent">
          <span className="entire-class-preview__n">
            1 – {formatNumber(totalShares)}
          </span>
          <span className="entire-class-preview__l">{t('NewNumbering')}</span>
        </div>
      </div>

      <p className="entire-class-preview__note">
        {t('EntireClassRenumerationDescription')}
      </p>

      <div className="range-row__header row g-1">
        <div className="col-3">
          <span className="range-row__col-label">{t('From')}</span>
        </div>
        <div className="col-3">
          <span className="range-row__col-label">{t('To')}</span>
        </div>
        <div className="col-3">
          <span className="range-row__col-label">{t('NewFrom')}</span>
        </div>
        <div className="col-3">
          <span className="range-row__col-label">{t('NewTo')}</span>
        </div>
      </div>

      {sample.map((range, index) => (
        <div
          className="form-control-wrap range-row__wrap"
          key={`preview-${range.key}`}
        >
          <div className="range-row row g-1 align-items-center">
            <div className="col-3">
              <span className="range-row__value">
                {formatNumber(range.from)}
              </span>
            </div>

            <div className="col-3">
              <span className="range-row__value">{formatNumber(range.to)}</span>
            </div>

            <div className="col-3">
              <InputNumber
                id={`preview-from-${index}`}
                value={range.newFrom as number}
                onChange={() => {}}
                lgSize={false}
                disabled
              />
            </div>

            <div className="col-3">
              <InputNumber
                id={`preview-to-${index}`}
                value={range.newTo as number}
                onChange={() => {}}
                lgSize={false}
                disabled
              />
            </div>
          </div>
        </div>
      ))}

      {remaining > 0 && (
        <div className="entire-class-preview__more">
          {t('PlusMoreRanges', { count: formatNumber(remaining) })}
        </div>
      )}
    </div>
  );
};

export default EntireClassRenumerationPreview;
